'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var BUTTON_TYPES = ['submit', 'reset', 'button'];

var BaseButton = function BaseButton(props) {
  return _react2['default'].createElement('button', {
    className: props.className,
    disabled: props.isDisabled,
    name: props.name,
    onClick: props.handleClick,
    type: props.type
  }, props.children);
};

BaseButton.propTypes = {
  isDisabled: _propTypes2['default'].bool,
  name: _propTypes2['default'].string,
  children: _propTypes2['default'].node.isRequired,
  className: _propTypes2['default'].string.isRequired,
  handleClick: _propTypes2['default'].func.isRequired,
  type: _propTypes2['default'].oneOf(BUTTON_TYPES)
};
BaseButton.defaultProps = {
  isDisabled: false,
  name: '',
  type: 'button'
};
exports['default'] = BaseButton;